import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  breakpoints, palette,
}: Theme) => ({
  paper: {
    '&&': {
      paddingTop: '2rem',
      paddingBottom: '2rem',
      [breakpoints.up('md')]: {
        paddingTop: '3rem',
        paddingBottom: '3rem',
      },
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2rem',
    '&&': {
      paddingLeft: '1rem',
      paddingRight: '1rem',
      [breakpoints.up('md')]: {
        paddingLeft: '3rem',
        paddingRight: '3rem',
      },
    },
  },
  image: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block',
    },
  },
  title: {
    [breakpoints.up('md')]: {
      fontSize: '1.75rem',
      lineHeight: 1.3,
    },
  },
  description: {
    margin: 0,
  },
  disclaimer: {
    margin: 0,
    fontSize: '0.75rem',
    lineHeight: 1.3,
    color: palette.text.disabled,
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
  },
  button: {
    '&&': {
      [breakpoints.down('md')]: {
        width: '100%',
      },
    },
  },
}));
